var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIphoneSmartPhoneSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,2H11C9.3,2,8,3.3,8,5v22c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V5C24,3.3,22.7,2,21,2z M17,27h-2c-0.6,0-1-0.4-1-1 s0.4-1,1-1h2c0.6,0,1,0.4,1,1S17.6,27,17,27z M22,22H10V8h12V22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneSmartPhoneSvgrepoCom);
export default __webpack_public_path__ + "static/media/iphone-smart-phone-svgrepo-com.c3525f9a04737d1715c5bf205c965d94.svg";
export { ForwardRef as ReactComponent };